import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { Layout, Button } from "antd"
import { Link } from "gatsby"

import styles from "./header.module.less"

const { Header } = Layout

const AppHeader = () => (
  <div className={styles.wrapper}>
    <Helmet title="ARP" defer={false}>
    </Helmet>

    {/* <Header>
      <div className={styles.container}>
        <Link to="/" className={styles.logo} />
      </div>
    </Header> */}
  </div>
)

export default AppHeader
